import * as actionTypes from '../actions/ActionTypes';
import TextConstant from '../../shared/constants/cardPurchaseConstants';

const initialCommonState = {
  couponCode: '',
  netAmount: '',
  discountPrice: '0',
};

const CardPurchaseReducer = (state = initialCommonState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PROMO_CODE:
      return {
        ...state,
        couponCode: action.couponCode,
        discountPrice: action.discountPrice,
      };
    case actionTypes.CLEAR_PROMO_CODE:
      return {
        ...state,
        netAmount: TextConstant.PAYMENT_AMOUNT_DOLLARS,
      };
    case actionTypes.UPDATE_PRICE:
      return {
        ...state,

        netAmount: action.netAmount,
      };

    case actionTypes.LOGOUT:
      return { ...initialCommonState };

    default:
      return state;
  }
};

export default CardPurchaseReducer;
